import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import IndividualPaymentCycleRegistrationForm from "../ones/IndividualPaymentCycleRegistrationForm";

export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	
	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	async function getData() {
		await callApi("get-individual-payment-cycle-data", { uuid }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready && data) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							{data.title}
							<br/>
							<span className="badge bg-dark">Individual Payment Cycle</span>
						</h6>
						<hr/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Title</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.title}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Description</label>
						<pre
							style={{
								fontSize: "18px",
							}}
						>
							{data.description || 'N/A'}
						</pre>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">Edit This Individual Payment Cycle</h6>
								<hr/>
								<IndividualPaymentCycleRegistrationForm callback={getData} data={data} />
							</div>
						</div>
					</div>
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}